var _rect, _rect2, _rect3, _rect4, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongMoban(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 4.25,
    height: 8.5,
    rx: 0.5,
    stroke: "#3F465C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.25,
    y: 5,
    width: 4.25,
    height: 8.5,
    rx: 0.5,
    stroke: "#3F465C"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 4.25,
    height: 8.5,
    rx: 0.5,
    stroke: "#3F465C"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 9.25,
    y: 5,
    width: 4.25,
    height: 8.5,
    rx: 0.5,
    stroke: "#3F465C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 13.5h4.25M9.25 2.5h4.25",
    stroke: "#3F465C",
    strokeLinecap: "round"
  })));
}
export default __webpack_public_path__ + "static/tongyong_moban.e0e9bc4e.svg";
export { SvgTongyongMoban as ReactComponent };